import React from 'react';
import ReactDOM from 'react-dom';

const Titulo = props => {
    return (<div className="row top-separator-xs">
        <div className="col-xs-12">
            <div className="row ">
                <div className="col-xs-12">
                    <h2 className='bottom-separator bottom-separator-xs'>
                        Datos Generales de la Cuenta
                    </h2>
                </div>
            </div>
        </div>
    </div>);
};

export default Titulo;